import type { ReactNode } from 'react';
import { useSession } from '../../state/session';
import { Icon } from '../ui/Icon';
import { NavRail } from './NavRail';
import { TopBar } from './TopBar';
import styles from './AppShell.module.css';

/** Frame of the whole app: ambient background, navigation, top bar, content. */
export function AppShell({ children }: { children: ReactNode }) {
  const { mode } = useSession();

  return (
    <div className={styles.shell}>
      <div className={styles.backdrop} aria-hidden="true">
        <span className={styles.scene} />
        <span className={`${styles.blob} ${styles.blobOne}`} />
        <span className={`${styles.blob} ${styles.blobTwo}`} />
        <span className={`${styles.blob} ${styles.blobThree}`} />
        <span className={styles.grain} />
      </div>

      <NavRail />

      <div className={styles.main}>
        {mode === 'preview' && (
          <div className={styles.previewBanner}>
            <Icon name="bolt" size={13} />
            Browser preview — a sandbox economy, not your server&apos;s.
          </div>
        )}
        <TopBar />
        <div className={styles.content}>
          <div className={styles.page}>{children}</div>
        </div>
      </div>
    </div>
  );
}
